// extracted by mini-css-extract-plugin
export default {"logo_link":"Logo_logo_link__AJS-9","logo__title":"Logo_logo__title__C53Dh","root":"Logo_root__2fUXk","wrapper":"Logo_wrapper__aH5ni","logo__img":"Logo_logo__img__zmYBe"};